import type { DxPopup } from "devextreme-vue/popup";
export type ModalPopupShellProps = Omit<DxPopup, "toolbarItems" | "showCloseButton">;
export type ModalPopupDimensionProps = Pick<ModalPopupShellProps, "width" | "maxWidth" | "height" | "maxHeight">;

export const modalMaxHeight = "80vh";

export const smModalPopupProps: ModalPopupDimensionProps = {
  width: 576,
  maxWidth: "80vw",
  height: "auto",
  maxHeight: modalMaxHeight,
};

export const mdModalPopupProps: ModalPopupDimensionProps = {
  width: 768,
  maxWidth: "80vw",
  height: "auto",
  maxHeight: modalMaxHeight,
};

export const lgModalPopupProps: ModalPopupDimensionProps = {
  width: 992,
  maxWidth: "80vw",
  height: "auto",
  maxHeight: modalMaxHeight,
};

export const xlModalPopupProps: ModalPopupDimensionProps = {
  width: 1200,
  maxWidth: "80vw",
  height: "auto",
  maxHeight: modalMaxHeight,
};

export const xxlModalPopupProps: ModalPopupDimensionProps = {
  width: 1400,
  maxWidth: "80vw",
  height: "auto",
  maxHeight: modalMaxHeight,
};